module.exports = __webpack_public_path__ + "static/media/blacklabelhotels.ac61cff7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/blacklabelhotels.webp
// module id = 464
// module chunks = 0